module.exports = __webpack_public_path__ + "darkimg-defaultblankspace.b6183953af8617427675d93c30e4cfd0.hashedasset.svg";